export default [  
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/modules/Home'),
    meta: {
      requiresAuth:true,
      layout: 'app',
      title: 'Home',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Summary' }
      ]
    }
  },
]